import axios from 'axios'
import store from './store'
import crypto from 'crypto'
import bcrypt from 'bcryptjs'
import util from 'util'
import { vals } from './util'

const config = require('./../config/settings')
const randomBytes = util.promisify(crypto.randomBytes)
const stringify = JSON.stringify

// check to see if we need to add auth
const authHandler = (request = {}) => {
  if (!(request.params && request.params.hasOwnProperty('authEnabled'))) return true
  let retval = !request.params.authEnabled ? false : true
  delete request.params.authEnabled
  return retval
}

const api = axios.create({
  baseURL: config.API_URL,
  headers: { 'Content-Type': 'application/json' }
})

// generate key for api
// using aes-128 so 16 byte keys
// const salt = bcrypt.genSaltSync(10)
const key = crypto.pbkdf2Sync(config.API_PWD, config.API_SALT, 10000, 16, 'sha512')
// const key = crypto.scryptSync(config.API_PWD, salt, 16) -- apparently not using node 10.5 in browser
const algorithm = 'aes-128-cbc'

let con_errors = 0
api.shouldForceLogout = false

// handle logging out if consecutive errors
api.interceptors.response.use((res) => {
  // reset error
  con_errors = 0
  api.shouldForceLogout = false
  return res
}, err => {
  // count error
  con_errors++
  api.shouldForceLogout = (con_errors > vals.MAX_NETWORK_ERRORS)
  return Promise.reject(err)
})

// decryption interceptor
api.interceptors.response.use(res => {
  return new Promise((resolve, reject) => {
    // console.log(`in decrypt: ${stringify(res.data)}`)
    // check to see if there is anything to decrypt
    if (res.data && res.data.decrypt && res.data._iv) {
      // console.log(`Decrypting: ${JSON.stringify(res.data.decrypt)}`)
      let data = res.data
      // iv should be specified in data
      let iv = new Buffer(data._iv, 'hex')
      const decipher = crypto.createDecipheriv(algorithm, key, iv)
      let decrypted = ''
      decipher.on('readable', () => {
        let chunk
        while (null !== (chunk = decipher.read())) {
          decrypted += chunk.toString('utf8')
        }
      })
      decipher.on('end', () => {
        delete data.decrypt
        delete data._iv
        decrypted = JSON.parse(decrypted)
        // if (typeof decrypted === 'string') decrypted = JSON.parse(decrypted)
        data.encrypt = decrypted
        // console.log(`Decrypted: ${JSON.stringify(data)}`)
        res.data = data
        resolve(res)
      })
      decipher.write(data.decrypt, 'hex')
      decipher.end()
    } else {
      // nope
      resolve(res)
    }
  })
})

// ecryption interceptor
api.interceptors.request.use(req => {
  return new Promise((resolve, reject) => {

    let isFormData = req.data instanceof FormData;
    // console.log(`in encrypt: ${stringify(req.data)}`)
    // check if we need to encrypt any of the data being sent up...
    if (req.data && (req.data.encrypt || isFormData)) {
      // console.log(`Encrypting: ${JSON.stringify(req.data.encrypt)}`)
      // have stuff to encrypt
      // generate our iv
      let data;
      if (isFormData) {
        data = JSON.parse(req.data.get('encrypt'));
      } else {
        data = req.data;
      }
      return randomBytes(16)
        .then(iv => {
          const cipher = crypto.createCipheriv(algorithm, key, iv)
          // with cipher we can now write our data
          let encrypted = ''
          cipher.on('readable', () => {
            let chunk
            while (null !== (chunk = cipher.read())) {
              encrypted += chunk.toString('hex')
            }
          })
          cipher.on('end', () => {
            // delete the encrypt field of data and set a 'decrypt'
            delete data.encrypt
            data.decrypt = encrypted
            data._iv = iv.toString('hex')

            if (isFormData) {
              req.data.delete('encrypt');
              req.data.append('encrypt', JSON.stringify(data));
            } else {
              req.data = data
            }
            // console.log(`Encrypted: ${JSON.stringify(req.data)}`)
            resolve(req)
          })
          if (typeof data.encrypt === 'object') data.encrypt = JSON.stringify(data.encrypt)
          cipher.write(JSON.stringify(data.encrypt))
          cipher.end()
        })
        .catch(err => {
          // console.error(`Error during encryption: ${err}`)
          reject(err)
        })
    }
    // nope
    resolve(req)
  })
})

api.interceptors.response.use(res => {
  return new Promise((resolve, reject) => {
    if (res.data && res.data.encrypt && res.data.encrypt.jwt) {
      // store the token in the user for future requests
      store.commit('user/token', { token: res.data.encrypt.jwt })
    }
    resolve(res)
  })
})

api.interceptors.request.use(req => {
  // console.log(`${store.getters['user/hasToken']}`)
  // console.log(`${util.inspect(req)}`)
  if (store.getters['user/hasToken'] && authHandler(req))
    req.headers['Authorization'] = `Bearer ${store.getters['user/token']}`
  return req
})

export default api